import axios from 'axios'

const metricsServices = {
  getReturnsAndExchangesRatio: ({ returnPortalId, params, headers, responseType = 'json' }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/items-transaction-type-data`, {
      params: { portal_id: returnPortalId, ...params },
      headers,
      responseType,
    }),
  getGeneralMetrics: ({ returnPortalId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/general`, { params: { portal_id: returnPortalId, ...params } }),
  getRefundMethodsMetrics: ({ returnPortalId, params, headers, responseType = 'json' }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/refund-methods`, {
      params: { portal_id: returnPortalId, ...params },
      headers,
      responseType,
    }),
  getDeliveryMethodsMetrics: ({ returnPortalId, params, headers, responseType = 'json' }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/delivery-methods`, {
      params: { portal_id: returnPortalId, ...params },
      headers,
      responseType,
    }),

  getTopReasons: ({ returnPortalId, params, headers, responseType = 'json' }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/top-return-reasons`, {
      params: { portal_id: returnPortalId, ...params },
      headers,
      responseType,
    }),
  getTopReturnedProducts: ({ returnPortalId, params, headers, responseType = 'json' }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/top-returned-products`, {
      params: { portal_id: returnPortalId, ...params },
      headers,
      responseType,
    }),
  getProductTopVariants: ({ returnPortalId, productId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/products/${productId}/metrics/top-variants`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getProductTopReasons: ({ returnPortalId, productId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/products/${productId}/metrics/top-return-reasons`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getVariantTopReasons: ({ returnPortalId, variantId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/variants/${variantId}/metrics/top-return-reasons`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getReasonTopReturnedProducts: ({ returnPortalId, reasonId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/return-reasons/${reasonId}/metrics/top-returned-products`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCustomerNotesAnalysis: ({ storeId, reasonId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/return-reasons/${reasonId}/metrics/customer-notes`, {
      params: { store_id: storeId, ...params },
    }),
  exportCustomerNotesAnalysis: ({ storeId, reasonId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/return-reasons/${reasonId}/metrics/customer-notes/export`, {
      params: { store_id: storeId, ...params },
      responseType: 'blob',
    }),
  getCustomerNotesByTopic: ({ storeId, reasonId, topicId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/return-reasons/${reasonId}/metrics/customer-notes/topics/${topicId}`, {
      params: { store_id: storeId, ...params },
    }),
  getReturnSalesRatio: ({ returnPortalId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/return-sales-ratio`, {
      params: { portal_id: returnPortalId, ...params },
    }),

  getCategoryTopReturnedProducts: ({ returnPortalId, categoryId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/product-types/${categoryId}/metrics/top-returned-products`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCategoryTopReasons: ({ returnPortalId, categoryId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/product-types/${categoryId}/metrics/top-return-reasons`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getTypeTopReturnedProducts: ({ returnPortalId, typeId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/categories/${typeId}/metrics/top-returned-products`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getTypeTopReasons: ({ returnPortalId, typeId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/categories/${typeId}/metrics/top-return-reasons`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCollectionTopReturnedProducts: ({ returnPortalId, collectionId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/collections/${collectionId}/metrics/top-returned-products`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCollectionTopReasons: ({ returnPortalId, collectionId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/collections/${collectionId}/metrics/top-return-reasons`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getTopCountries: ({ returnPortalId, params, headers, responseType = 'json' }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/top-countries`, {
      params: { portal_id: returnPortalId, ...params },
      headers,
      responseType,
    }),
  getTopSubReason: ({ returnPortalId, reasonId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/return-reasons/${reasonId}/metrics/subreasons`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getReasonSummary: ({ returnPortalId, reasonId, params }, config) => {
    return axios.get(`${import.meta.env.VITE_HOST}/return-reasons/${reasonId}/metrics/summary`, {
      params: { portal_id: returnPortalId, ...params },
      signal: config?.signal,
    })
  },
  getVariantReturnsAndExchangesRatio: ({ returnPortalId, variantId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/variants/${variantId}/metrics/items-transaction-type-data`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getVariantReturnsSalesRatio: ({ returnPortalId, variantId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/variants/${variantId}/metrics/return-sales-ratio`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getProductReturnsAndExchangesRatio: ({ returnPortalId, productId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/products/${productId}/metrics/items-transaction-type-data`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getProductReturnsSalesRatio: ({ returnPortalId, productId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/products/${productId}/metrics/return-sales-ratio`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCategoryReturnsAndExchangesRatio: ({ returnPortalId, categoryId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/product-types/${categoryId}/metrics/items-transaction-type-data`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCategoryReturnsSalesRatio: ({ returnPortalId, categoryId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/product-types/${categoryId}/metrics/return-sales-ratio`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getTypeReturnsAndExchangesRatio: ({ returnPortalId, typeId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/categories/${typeId}/metrics/items-transaction-type-data`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getTypeReturnsSalesRatio: ({ returnPortalId, typeId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/categories/${typeId}/metrics/return-sales-ratio`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCollectionReturnsAndExchangesRatio: ({ returnPortalId, collectionId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/collections/${collectionId}/metrics/items-transaction-type-data`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getCollectionReturnsSalesRatio: ({ returnPortalId, collectionId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/collections/${collectionId}/metrics/return-sales-ratio`, {
      params: { portal_id: returnPortalId, ...params },
    }),
  getAllStoresReturnSalesRatio: ({ params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/all-stores-return-sales-ratio`, {
      params,
    }),
  getAlerts: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics/alerts`, { params: { portal_id: returnPortalId } }),
  getShipmentsGeneralMetrics: ({ storeId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments-metrics/general`, {
      params,
    }),
  getPerformanceInsightsAvailability: ({ storeId, params }, config) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/performance-insights/availability`, {
      params,
      signal: config?.signal,
    })
  },
  getShipmentsCountriesMetrics: ({ storeId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments-metrics/countries`, {
      params,
    }),
  getShipmentsBestSellingProductsOriginMetrics: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments-metrics/country-of-origin`, {
      params: { time_range: 'year' },
    }),
  getShipmentsDeliveryTimeByCarrierMetrics: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/shipments-metrics/carrier-services`, {
      params: { time_range: 'year' },
    }),
}

export default metricsServices
